export default "__VITE_ASSET__CDtSJHsZ__"